/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Mortgage_PercentInputs */

const cs_form_mortgage_percent = /** @type {(inputs: Form_Mortgage_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procento hypotéky`)
};

const en_form_mortgage_percent = /** @type {(inputs: Form_Mortgage_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mortgage percent`)
};

/**
* | output |
* | --- |
* | "Mortgage percent" |
*
* @param {Form_Mortgage_PercentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_mortgage_percent = /** @type {((inputs?: Form_Mortgage_PercentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Mortgage_PercentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_mortgage_percent(inputs)
	return cs_form_mortgage_percent(inputs)
});